import { FC, useCallback } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Field, Form } from "react-final-form";
import { Button, Heading, Spinner } from "@chakra-ui/react";
import _ from "lodash";
import { CustomInput, CustomPasswordInput } from "../../../customComponents/components";
import { useLogin } from "../../hooks/useLogin";
import { validate } from "../../helpers";
import {
  ButtonField,
  ErrorText,
  InputFields,
  LoginForm,
  LoginWrapper,
} from "./styles";

export const LoginScreen: FC = () => {
  const [data, loading, request, errors] = useLogin();

  const navigate = useNavigate();

  const onSubmit = useCallback(
    async (values: { password: string; login: string }): Promise<void> => {
      if (_.isObject(values) && values?.password && values?.login) {
        await request(values);
        navigate("/");
      }
    },
    []
  );

  if (data?.access_token) {
    return <Navigate replace to="/" />;
  }
  return (
    <LoginWrapper>
      <Form
        mutators={{
          setValue: ([field, value], state, { changeValue }) => {
            changeValue(state, field, () => value);
          },
        }}
        onSubmit={onSubmit}
        initialValues={{ login: "", password: "" }}
        validate={validate}
        render={({ form, handleSubmit, submitting, pristine }) => {
          //@ts-ignore
          window.form = form;
          return (
            <LoginForm onSubmit={handleSubmit}>
              <Heading as="h3" size="md">
                Вход
              </Heading>
              <InputFields>
                <Field
                  name="login"
                  placeholder="Логин"
                  label="Логин"
                  component={CustomInput}
                  type="text"
                />
                <Field
                  name="password"
                  placeholder="Пароль"
                  label="Пароль"
                  type="password"
                  component={CustomPasswordInput}
                />
              </InputFields>
              {errors && <ErrorText>{errors}</ErrorText>}
              <ButtonField>
                <Button
                  type="submit"
                  colorScheme="teal"
                  variant="outline"
                  size="lg"
                  isDisabled={submitting || pristine}
                >
                  {loading ? <Spinner /> : "Вход"}
                </Button>
              </ButtonField>
            </LoginForm>
          );
        }}
      ></Form>
    </LoginWrapper>
  );
};
